import foldToASCII from 'data/foldToASCII';
export class FaqUnknownQuestionsController {
    // Explicit AngularJS DI annotation for minification safety
    //Getters and Setters
    get application() {
        return this._application;
    }
    set application(value) {
        this._application = value;
    }
    constructor(LoadingService, FaqService, PermissionsService, application, ngToast, $sce, $scope, $timeout, $translate) {
        'ngInject';
        // AngularJS explicit DI annotation (minification-safe)
        // Order MUST match constructor parameters
        // Removed reliance on 'ngInject' to avoid plugin misses in TS
        // static $inject inserted above constructor
        this._loadingService = LoadingService;
        this._faqService = FaqService;
        this._permissionsService = PermissionsService;
        this.application = application;
        this._ngToast = ngToast;
        this._$sce = $sce;
        this._$scope = $scope;
        this._$timeout = $timeout;
        this._$translate = $translate;
        this.responses = [];
        this._unknownQuestions = [];
        this.autocompleteFocused = false;
        //Pagination
        this.itemsPerPage = 20;
        this.perPageAux = 0;
        this.query();
    }
    get unknownQuestions() {
        return this._unknownQuestions;
    }
    set unknownQuestions(unknownQuestions) {
        this._unknownQuestions = unknownQuestions;
    }
    //Undo exclusion
    undo() {
        if (this._tempObj) {
            this._unknownQuestions.push(this._tempObj);
            this._excludeObj = false;
            this._tempObj = undefined;
            this._ngToast.dismiss();
        }
    }
    //Search for unknownQuestions
    customSearch(str, data) {
        return data.filter((x) => {
            const itemTxt = foldToASCII(x.body);
            const srcTxt = foldToASCII(str);
            return itemTxt.toLowerCase().indexOf(srcTxt.toLowerCase()) > -1
                ? x
                : '';
        });
    }
    async loadMore() {
        if (!this.canLoadMore || this.isLoading) {
            return;
        }
        this.perPageAux += this.itemsPerPage;
        await this.query();
    }
    //Init screen with neccesary data
    async query() {
        this._hasPermission = await this._permissionsService.hasPermissions('write');
        if (this.isLoading || this.noMoreItems) {
            return;
        }
        this.canLoadMore = false;
        this.isLoading = true;
        this._loadingService.startLoading();
        try {
            await Promise.all([this._loadQuestions(), this.loadResponses()]);
        }
        catch (e) {
            throw e;
        }
        finally {
            this.canLoadMore = true;
            this.isLoading = false;
            this._loadingService.stopLoading();
        }
    }
    //Assign item obj item obj to it index var
    selectResponse(unknownQuestion, item) {
        //this.selectedItem[index] = item;
        unknownQuestion.response = item;
    }
    //Load unknown questions
    async _loadQuestions() {
        try {
            let payload;
            payload = {
                skip: this.perPageAux,
                take: this.itemsPerPage,
            };
            const { items } = await this._faqService.getUnknownQuestions(payload);
            if (items.length == 0) {
                this.noMoreItems = true;
                this.canLoadMore = false;
                return;
            }
            this._unknownQuestions.push(...items);
        }
        catch (e) {
            const errorMsg58 = await this._$translate('utils.errorMsg.58');
            this._ngToast.danger(errorMsg58);
            this.noMoreItems = true;
            throw e;
        }
    }
    //Load available responses
    async loadResponses() {
        if (this.responses.length == 0) {
            try {
                let allItems = [];
                let skip = 0;
                const take = 100;
                const isTrue = true;
                while (isTrue) {
                    const { items } = await this._faqService.getIntentions({ skip: skip, take: take }); // eslint-disable-line no-await-in-loop
                    allItems = allItems.concat(items);
                    if (items.length < take) {
                        break;
                    }
                    skip += take;
                }
                this.responses = allItems
                    .map((item) => item.body.length > 60
                    ? {
                        ...item,
                        body: item.body
                            .replace(/\n/g, ' ')
                            .slice(0, 60) + '...',
                    }
                    : {
                        ...item,
                        body: item.body.replace(/\n/g, ' '),
                    })
                    .filter((x) => !x.deleted);
                return this.responses;
            }
            catch (e) {
                const errorMsg24 = this._$translate('utils.errorMsg.24');
                this._ngToast.danger(errorMsg24);
                this.noMoreItems = true;
                throw e;
            }
        }
    }
    //Assign unknown question to selected response
    async assignToResponse(unknownQuestion) {
        if (!this._hasPermission) {
            const errorMsg74 = this._$translate.instant('utils.errorMsg.74');
            this._ngToast.danger(errorMsg74);
            return;
        }
        const response = unknownQuestion.response;
        if (!response) {
            const errorMsg59 = await this._$translate('utils.errorMsg.59');
            this._ngToast.danger(errorMsg59);
            return;
        }
        try {
            this._loadingService.startLoading();
            const requestResource = {
                guid: unknownQuestion.guid,
                idRule: response.id,
            };
            await this._faqService.setRequestFeedback(requestResource, response.referenceName);
            const resource = {
                idRule: response.id,
                text: unknownQuestion.userInput,
            };
            await this._faqService.addQuestion(resource, response.referenceName);
            this._unknownQuestions.remove(unknownQuestion);
            const errorMsg = await this._$translate('modules.application.detail.templates.faq.assignedToResponse');
            this._ngToast.success(errorMsg);
        }
        catch (e) {
            if (e.description.indexOf('The entity already exists') != -1) {
                const existingQuestion = await this._$translate('modules.application.detail.templates.faq.existingQuestion');
                this._ngToast.danger(existingQuestion);
                this._unknownQuestions.remove(unknownQuestion);
                return;
            }
            const errorOnAssignToResponse = await this._$translate('modules.application.detail.templates.faq.errorOnAssignToResponse');
            this._ngToast.danger(errorOnAssignToResponse);
            throw e;
        }
        finally {
            this._loadingService.stopLoading();
        }
    }
    //Remove unknown question
    //If user don't click on "Desfazer exclusão" in 3 seconds, unknownQuestion is deleted permanently from database
    async removeQuestion(unknownQuestion) {
        if (!this._hasPermission) {
            const errorMsg74 = this._$translate.instant('utils.errorMsg.74');
            this._ngToast.danger(errorMsg74);
            return;
        }
        this._excludeObj = true;
        const undoExclusion = await this._$translate('modules.application.detail.templates.faq.undoExclusion');
        this._ngToast.create({
            content: this._$sce.trustAsHtml(`<div ng-click="$ctrl.undo()"><icon-dpr>&#xE166;</icon-dpr> ${undoExclusion}</div>`),
            compileContent: this._$scope,
            dismissOnClick: false,
            dismissButton: false,
            timeout: 3000,
        });
        this._tempObj = unknownQuestion;
        this._unknownQuestions.remove(unknownQuestion);
        this._$timeout(() => {
            this.deleteQuestionFromApi(unknownQuestion);
        }, 3500);
    }
    async deleteQuestionFromApi(unknownQuestion) {
        if (this._unknownQuestions.length < 5) {
            this._loadQuestions();
        }
        if (this._excludeObj) {
            try {
                const requestResource = {
                    guid: unknownQuestion.guid,
                };
                await this._faqService.deleteUnknownQuestion(requestResource);
            }
            catch (e) {
                const errorMsg26 = await this._$translate('utils.errorMsg.26');
                this._ngToast.danger(errorMsg26);
                throw e;
            }
        }
    }
}
